import type { GlobalCreditAccountFragment } from "@src/__generated__/graphql";
import type { IOption } from "@src/components/ui-kit";
import { currency } from "@src/utils/formatters";

interface GlobalCreditAccount
  extends Pick<GlobalCreditAccountFragment, "id" | "title"> {
  stats: {
    remaining_credit: GlobalCreditAccountFragment["stats"]["remaining_credit"];
  };
}
export function globalCreditAccounts(data: GlobalCreditAccount[]): IOption[] {
  return data.map((item) => ({
    label: `${item.title} (${currency.formatByWorkspace(item.stats.remaining_credit)})`,
    value: item.id,
  }));
}
